import React from "react";
import PackageRow from "./PackageRow";

export default function DraggablePackageRow({
	pck,
	index,
	onSelectRow,
	onToggleForceDisplay,
	onDragStart,
	onDragEnd,
	onDragOver,
}) {
	const handleDragStart = (e) => {
		e.dataTransfer.effectAllowed = "move";
		e.dataTransfer.setData("text/html", e.currentTarget);
		onDragStart(index);
	};

	const handleDragOver = (e) => {
		e.preventDefault();
		e.dataTransfer.dropEffect = "move";
		onDragOver(index);
	};

	const handleDrop = (e) => {
		e.preventDefault();
		e.stopPropagation();
	};

	return (
		<div
			draggable
			onDragEnd={onDragEnd}
			onDragOver={handleDragOver}
			onDragStart={handleDragStart}
			onDrop={handleDrop}
		>
			<PackageRow index={index} pck={pck} onSelectRow={onSelectRow} onToggleForceDisplay={onToggleForceDisplay} />
		</div>
	);
}
